namespace st.search {
    class TermFacetController implements controllers.ITermFacetController {

        group: string = DefaultGroup;
        name: string;
        model: string;
        private _term: string;

        static $inject = ['$rootScope', 'stFacetService'];

        constructor($rootScope: angular.IRootScopeService, private stFacetService: services.IFacetService) {
            $rootScope.$on('stRegisterFacets', (e: angular.IAngularEvent) => {
                stFacetService.registerFacets(this.group, TermPropertyName, this);
            });

            $rootScope.$on('stFacetsInit', (e, search: { term: string }, groups: string[]) => {
                if (this._term !== search.term || this.model !== search.term) {
                    this._term = this.model = search.term;
                    groups.push(this.group);
                }
            });
        }

        get term(): string {
            return this._term;
        }
        set term(val: string) {
            if (this._term !== val) {
                this._term = this.model = val;
                this.stFacetService.update(TermPropertyName, this.group);
            }
        }

        notify(): void {
            this.term = this.model;
        }
    }

    angular.module('st.search')
        .controller('stTermFacetCtrl', TermFacetController);
}
